import { useQuery } from '@tanstack/react-query'
import { notificationsList } from '..'
import cacheKeys from '../../../../services/cacheKeys'
import { useEffect } from 'react'

const useNotificationList = (page: number, limit: number, count: number) => {
  const query = useQuery({
    queryKey: [cacheKeys.NOTIFICATION, page, limit],
    queryFn: notificationsList,
    enabled: true,
  })

  useEffect(() => {
    if (count) {
      query.refetch()
    }
  }, [count, page, limit])

  return query
}

export default useNotificationList
